import { Injectable } from "@angular/core";
import { DataModel, MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { MentorFormDataService } from "common/services/data-services/admin/mentor/mentor-form-data.service";
import { stateListDataService } from "common/services/data-services/custom-service/stateList-service.service";
import { CompanyGridDataService } from "common/services/data-services/admin/internship-company/company-grid-data.service";
import { MentorModel } from "common/models/page-models/mentor/mentor-data-model";
import { MentorMetaModel } from "common/models/page-models/mentor/mentors-meta-model";
import { data } from "jquery";

@Injectable({
    providedIn: 'root'
})

export class  MentorFormWidgetService extends FormWidgetService<MentorModel> {
    constructor(protected ds: MentorFormDataService, private stateService: stateListDataService, private internshipCompanyService: CompanyGridDataService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new MentorMetaModel();
        return meta.getMetaModel();
    }

  
    override prepareMetaModel(dataModel: DataModel, metaModel: MentorMetaModel, routeData: WidgetModel): Promise<MentorMetaModel> {
        return new Promise<MentorMetaModel>((resolve, reject) => {
            // console.log(dataModel)
            metaModel.pageTitle = dataModel.id !== 0 ?  'Update Mentor' : 'Add Mentor';
            this.stateService.postData('').then((data) => {
                metaModel.properties['mentorStateId'].options = data.details;
            });
            this.internshipCompanyService.postData('').then((data) => {
                metaModel.properties['mentorCompany'].options = data.detail;
            });
            resolve(metaModel);
        });
    }
}
